var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsletter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_26299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.23096 15.17L1.45259 30.927L32.9664 36.4837L35.7448 20.7268L19.1889 25.3014L4.23096 15.17Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99586 16.6793L8.60059 1.90723L36.1752 6.76938L33.5705 21.5415",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.51 19.9439L25.6429 13.5191C25.8423 12.3885 25.7837 11.511 25.2614 10.765C24.7276 10.0027 23.893 9.65651 22.8176 9.46689L20.8323 9.11681C19.7155 8.9199 18.838 8.97841 18.092 9.5008C17.3459 10.0232 16.9746 10.8391 16.7777 11.9559L16.0508 16.0783C15.832 17.3191 16.0356 17.9379 16.6975 18.7796L18.1572 17.7576C17.7727 17.2775 17.6697 16.975 17.7912 16.2857L18.4938 12.3011C18.5959 11.7221 18.754 11.3092 19.2243 10.9799C19.6784 10.6619 20.1366 10.6432 20.6881 10.7405L22.3978 11.0419C22.9493 11.1391 23.3961 11.3459 23.6914 11.7676C23.998 12.2055 24.0281 12.6799 23.926 13.259L23.8166 13.8794C23.4832 13.3515 23.012 13.0409 22.3088 12.9169C21.5919 12.7905 20.9253 12.9431 20.4476 13.3138C19.7892 13.8232 19.58 14.5255 19.3637 15.7526C19.1449 16.9935 19.0987 17.7388 19.5571 18.4451C19.8929 18.9592 20.4558 19.3144 21.1727 19.4408C21.931 19.5745 22.4273 19.4203 22.9536 19.0156L22.8418 19.6498L24.51 19.9439ZM23.362 16.4576C23.1699 17.5468 22.7864 18.19 21.904 18.0344C21.0216 17.8788 20.895 17.1457 21.0871 16.0565C21.2791 14.9673 21.6464 14.3355 22.5288 14.4911C23.4112 14.6467 23.554 15.3684 23.362 16.4576Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_26299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 31.82,
    fill: "white",
    transform: "translate(5.81982 0.401489) rotate(10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/Newsletter.8dfe7930990cd3c785bfe49ca513b901.svg";
export { ForwardRef as ReactComponent };